/** Premier cran prêté à une échelle d'évaluation dont le paramétrage ne dit rien : elle part de un. */
export const DEFAULT_SCALE_START = 1;
